import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal } from 'antd'
import ReplyMessage from './reply'

const MessageDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [messageDetail, setMessageDetail] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isReplyVisible, setIsReplyVisible] = useState(false)

  const getMessageDetail = () => {
    axios.post('/p/content/message/detail/get', {
      merchant_oid: merchantOid,
      message_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setMessageDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getMessageDetail()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, props.data.oid])

  const handleCancel = () => {
    props.isCancel()
  }

  const getColor = () => {
    if (messageDetail.status === 1) return 'green'
    return 'orange'
  }

  const openReply = () => {
    setIsReplyVisible(true)
    setPropsData({
      oid: messageDetail.oid,
      reply_content: messageDetail.reply_content
    })
  }

  return (
    <Modal
      title="留言详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>

      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>留言时间</div>
          <div className='public-datail-content'>{messageDetail.create_time}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>留言用户</div>
          <div className='public-datail-content'>{messageDetail.consumer_nickname}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>联系方式</div>
          <div className='public-datail-content'>{messageDetail.contact || '未填写'}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>留言内容</div>
          <div className='public-datail-content' style={{whiteSpace: 'pre-wrap'}}>{messageDetail.content}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>回复状态</div>
          <div style={{ color: getColor() }} className='public-datail-status'>{messageDetail.status_value}</div>
          <div className='public-datail-button' onClick={openReply}>回复</div>
        </div>
        {messageDetail.status === 1 &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>回复内容</div>
            <div className='public-datail-content' style={{whiteSpace: 'pre-wrap'}}>{messageDetail.reply_content}</div>
          </div>
        }
        {messageDetail.status === 1 &&
          <div className='public-datail-item'>
            <div className='public-datail-label'>回复时间</div>
            <div className='public-datail-content'>{messageDetail.reply_time}</div>
          </div>
        }
      </div>

      {isReplyVisible && <ReplyMessage
        data={propsData}
        getMessageDetail={getMessageDetail}
        getMessageData={() => { props.getMessageData() }}
        isOpen={isReplyVisible}
        isCancel={() => { setIsReplyVisible(false) }}
      />}
    </Modal>
  )
}

export default MessageDetail
